import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const Islogin = localStorage.getItem("token");

  return Islogin ? <Outlet /> : <Navigate to={"/login"} />;
};

export default PrivateRoute;
